import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAllUsers, deleteUser } from "../server/rolesAllApi";
import axios from "axios";
// for deletion
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import { Tooltip } from 'react-tooltip';

const CoursesLayer = () => {
  const [courses, setCourses] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [roleName, setRoleName] = useState("");
  const [userName, setUserName] = useState("");
  const [tooltipId] = useState('brief-tooltip');
  const [expandedBrief, setExpandedBrief] = useState(null);

  useEffect(() => {
    const storedToken = localStorage?.getItem("token");
    const user = localStorage?.getItem("user");
    const parsedUser = JSON.parse(user);
    const role = parsedUser?.rolename;
    const userEmail = parsedUser?.userName;
    setUserName(userEmail);
    setRoleName(role);
    // console.log(role);
 
    setToken(storedToken);
  }, []);

  

  useEffect(() => {
    if (token) {
      // console.log("rolessssss: ", roleName);
      // console.log("userssssss: ", userName);
      
      if(roleName==="Admin"){
        fetchDepartments();
      }else if(roleName==="Tutor"){
        if (userName === "E2TMT0001"){
          fetchDepartments();
        } else {
          fetchCoursesbytutor();
        }
      }
      
      fetchdepartment();
    }
  }, [token, currentPage, itemsPerPage,roleName, searchTerm, selectedDepartment,selectedCourseCategory]);

  useEffect(() => {
    fetchCourseCategories();
  }, [selectedDepartment]);

  // useEffect(() => {
  //   fetchCourseBycoursecategory();
  // }, [selectedCourseCategory]);

  const fetchDepartments = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Course?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&department=${selectedDepartment}&level=${selectedCourseCategory}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );


      // console.log("Response received:", response);
      const responseData = response.data.data?.data || response.data.data;
      const responsePagination = response.data.pagination || response.data.data?.pagination;
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = responseData.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setCourses(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(responsePagination.totalItems); // Set totalItems for pagination
      setTotalPages(responsePagination.totalPages);
      // console.log("total items, total pages : ", totalItems, totalPages);
    } catch (error) {
      console.error("Failed to fetch departments:", error);
      setError("Failed to fetch departments.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCoursesbytutor = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-by-tutor?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );


      // console.log("Response received:", response);
      const responseData = response.data.data?.data || response.data.data;
      const responsePagination = response.data.pagination || response.data.data?.pagination;
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = responseData.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setCourses(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(responsePagination.totalItems); // Set totalItems for pagination
      setTotalPages(responsePagination.totalPages);
      // console.log("total items, total pages : ", totalItems, totalPages);
    } catch (error) {
      console.error("Failed to fetch departments:", error);
      setError("Failed to fetch departments.");
    } finally {
      setLoading(false);
    }
  };

  const fetchdepartment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCourseCategories = async () => {
    // Check if selectedDepartment is available before making the request
    if (!selectedDepartment) {
      // console.log("Department not selected.");
      return;
    }

    // Ensure we have a valid token
    if (!token) {
      // console.log("Access required: No token provided.");
      return;
    }

    try {
      // Fetch course categories
      const courseCategoriesResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Handle the course categories data
      const courseCategoriesData = courseCategoriesResponse.data?.data;
      if (courseCategoriesData) {
        setCourseCategories(courseCategoriesData);
        // console.log(
        //   "Course categories fetched successfully:",
        //   courseCategoriesData
        // );
      } else {
        // console.log("No course categories found.");
      }

      
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
    }
  };



  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleEditDepartment = (course) => {
    // console.log("course data: ", course);

    navigate("/edit-course", { state: { course } });
  };

  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeleteDepartment(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleDeleteDepartment = async (course) => {
    try {
      // const res = await deleteDepartment(department._id, reqHeader);
      const response = await fetch(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-course/${course._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();

        fetchDepartments();
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleToggleStatus = async (course) => {
    try {
      const updatedStatus = !course.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/course-status-update/${course._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        if(roleName==="Admin"){
        fetchDepartments((prevcourse) =>
          prevcourse.map((b) =>
            b._id === course._id ? { ...b, status: updatedStatus } : b
          )
        );}
        else if(roleName==="Tutor"){
          fetchCoursesbytutor((prevcourse) =>
          prevcourse.map((b) =>
            b._id === course._id ? { ...b, status: updatedStatus } : b
          )
        );
        }

        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle course status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleViewCourse = (course) => {
    // console.log("Course data: ", course);
    navigate(`/view-course`, { state: { course } });
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>
          
          {roleName === "Admin" && (
  <>
    {/* Department Dropdown */}
    <select
      className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
      value={selectedDepartment}
      onChange={(e) => {
        setSelectedDepartment(e.target.value);
        setSelectedCourseCategory(""); // Reset course category when department changes
      }}
    >
      <option value="">Select Department</option>
      {departments.length > 0 ? (
        departments.map((department) => (
          <option key={department._id} value={department._id}>
            {department.department_name}
          </option>
        ))
      ) : (
        <option disabled>No departments available</option>
      )}
    </select>

    {/* Course Category Dropdown (Level) */}
    {selectedDepartment && (
      <select
        className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
        value={selectedCourseCategory}
        onChange={(e) => setSelectedCourseCategory(e.target.value)}
      >
        <option value="">Select Level</option>
        {courseCategories.length > 0 ? (
          courseCategories.map((level) => (
            <option key={level?._id} value={level?._id}>
              {level?.courseCategoryName}
            </option>
          ))
        ) : (
          <option disabled>No course categories available</option>
        )}
      </select>
    )}
  </>
)}

        </div>
        {roleName === "Admin" && (
        <Link
          to="/add-course"
          className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon
            icon="ic:baseline-plus"
            className="icon text-xl line-height-1"
          />
          Add New
        </Link>)}
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col" style={{ width: "10px" }}>
                  <div className="d-flex align-items-center gap-10">S.L</div>
                </th>
                <th scope="col" style={{ width: "200px" }}>
                  Department
                </th>
                <th scope="col" style={{ width: "100px" }}>
                  Level
                </th>
                <th scope="col" style={{ width: "160px" }}>
                  Course
                </th>
                <th scope="col" style={{ width: "100px" }}>
                  Fees
                </th>
                <th scope="col" style={{ width: "100px" }}>
                  Price
                </th>
                <th scope="col" style={{ width: "106px" }}>
                  Duration
                </th>
                <th scope="col" style={{ width: "270px" }}>
                  Brief
                </th>
                <th scope="col" style={{ width: "270px" }}>
                  Created At
                </th>
                <th
                  scope="col"
                  className="text-center"
                  style={{ width: "100px" }}
                >
                  Status
                </th>
                <th
                  scope="col"
                  className="text-center"
                  style={{ width: "120px" }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {courses.length > 0 ? (
                courses.map((course, index) => (
                  <tr key={course?._id}>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <div className="d-flex align-items-center gap-10">
                        {course?.serial}
                      </div>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      {course?.department?.department_name}
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {course?.level?.courseCategoryName}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {course?.coursename}
                      </span>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {course?.fees}
                      </span>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {course?.price}
                      </span>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {course?.duration} Weeks
                      </span>
                    </td>
                    {/* <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {course?.brief?.length > 100 ? (
                          <>
                            {course.brief.substring(0, 100)}...
                            <button 
                              className="btn btn-link p-0 text-primary"
                              data-tooltip-id={tooltipId}
                              data-tooltip-content={course.brief}
                            >
                              Read More
                            </button>
                            <Tooltip 
                              id={tooltipId}
                              place="top"
                              style={{
                                maxWidth: '300px',
                                whiteSpace: 'pre-wrap',
                                fontSize: '14px',
                                padding: '8px',
                                zIndex: 1000
                              }}
                            />
                          </>
                        ) : (
                          course?.brief
                        )}
                      </span>
                    </td> */}
                    <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {expandedBrief === course?._id ? (
                          <>
                            {course?.brief}
                            <button 
                              className="btn btn-link p-0 text-primary ms-2"
                              onClick={() => setExpandedBrief(null)}
                            >
                              Read Less
                            </button>
                          </>
                        ) : (
                          <>
                            {course?.brief?.substring(0, 100)}
                            {course?.brief?.length > 100 && (
                              <>
                                ...
                                <button 
                                  className="btn btn-link p-0 text-primary ms-2"
                                  onClick={() => setExpandedBrief(course?._id)}
                                >
                                  Read More
                                </button>
                              </>
                            )}
                          </>
                        )}
                      </span>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                      {new Date(
                          course?.createdAt
                        ).toLocaleDateString()}{" "}
                        {new Date(
                          course?.createdAt
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </td>
                    <td className="text-center">
                      <button
                        onClick={() => handleToggleStatus(course)}
                        className={`bg-${
                          course?.status ? "success" : "danger"
                        }-focus text-${
                          course?.status ? "success" : "danger"
                        }-600 border border-${
                          course?.status ? "success" : "danger"
                        }-main px-24 py-4 radius-4 fw-medium text-sm`}
                        style={{ cursor: "pointer" }}
                      >
                        {course?.status ? "Active" : "Inactive"}
                      </button>
                    </td>
                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        {/* <button
                      type="button"
                      className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                      
                    >
                      <Icon
                        icon="majesticons:eye-line"
                        className="icon text-xl"
                      />
                    </button> */}
                        <button
                          type="button"
                          className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleViewCourse(course)}
                        >
                          <Icon
                            icon="majesticons:eye-line"
                            className="icon text-xl"
                          />
                        </button>
                        {roleName === "Admin" && (
                        <button
                          type="button"
                          className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleEditDepartment(course)}
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>)}
                        {/* for deletion */}
                        {roleName === "Admin" && (
                        <button
                          type="button"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleDeleteClick(course)}
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>)}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No course found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing{" "}
            {courses.length === 0
              ? "0"
              : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
            to {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
            {totalItems} entries
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  pointerEvents: currentPage === 1 ? "none" : "auto",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>

            {/* Current Page Number */}
            <li className="page-item">
              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                {currentPage}
              </span>
            </li>

            {/* Next Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
        {/* for deletion */}
        <Modal
          show={showDeleteModal}
          onHide={handleCloseDeleteModal}
          centered
          backdrop="static"
          size="sm"
        >
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-24 text-center">
              <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
              </span>
              <h6 className="text-lg fw-semibold text-primary-light mb-0">
                Are you sure you want to delete this course?
              </h6>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleCloseDeleteModal}
                  className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleConfirmDelete}
                  className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default CoursesLayer;
